import {FIELDS} from '../feature/services/rinforzo-nodo/index'
const getNodeReinforcementCSVAttachments = (nodeReinforcements, sep=';') => {
    let attachments = []
    for (let nodeReinforcement of nodeReinforcements) {
        let columns = Object.keys(nodeReinforcement.value)
        const columnsForCSV = columns.map((c)=>{
            if (FIELDS[c] && FIELDS[c].mu){
                return c + " [" + FIELDS[c].mu + "]"
            }else{
                return c
            }
        })
        let csvContent = columnsForCSV.join(sep) + "\n"
        for (let column of columns) {
            csvContent += nodeReinforcement.value[column] + sep
        }
        csvContent = csvContent.slice(0, -1)
        attachments.push({
            "Body": btoa(csvContent),
            "ContentType": "text/csv",
            "Name": nodeReinforcement.question.name + ".csv"
        });
    }
    return attachments
}

export default getNodeReinforcementCSVAttachments;